import React, { useEffect, useState } from 'react';
import { Exemption, SplitTaxCollected } from '../../types';
import colors from 'css/colors';
import ActionButton from 'components/ui/ActionButton';
import axios from 'axios';
import { Checkbox } from 'semantic-ui-react';
import ConfirmActionModal from 'components/ui/ConfirmActionModal';
import { ExemptionPortion } from './ExemptionPortion';

export const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: 280,
  }),
  control: (provided: any, state: { isFocused: boolean }) => ({
    ...provided,
    boxShadow: state.isFocused && '1px solid #ff5252',
    border: state.isFocused ? '1px solid #ff5252' : `1px solid ${colors.grey}`,
    height: 48,
    '&:hover': {
      border: state.isFocused && '1px solid #ff5252',
    },
  }),
};
interface PropTypes {
  taxDetails: SplitTaxCollected;
  taxIndex: number;
  changeFunction: (key: string, value: any, index: number, name?: string, exIndex?: number) => void;
  removeFunction: (index: number, key: string, value: any) => void;
  isPriorItem: boolean;
}

const Exemptions = (props: PropTypes) => {
  const [exemptionTypes, setExemptionTypes] = useState<any>([]);
  const [showConfirmCreateOption, setShowConfirmCreateOption] = useState(false);
  const [newExemption, setNewExemption] = useState<any>();
  const [newExemptionIndex, setNewExemptionIndex] = useState(0);
  const { taxDetails, taxIndex } = props;
  const getExemptionTypes = async () => {
    const { data } = await axios.get(`/api/property/GetDropdownTypes/${1}/${1}`);
    setExemptionTypes(data);
  };
  const addExemption = async (e: any, i: number) => {
    if (e.__isNew__) {
      setNewExemption(e);
      setNewExemptionIndex(i);
      setShowConfirmCreateOption(true);
    } else {
      props.changeFunction('exemptions', e, taxIndex, 'type', i);
    }
  };
  useEffect(() => {
    getExemptionTypes();
  }, []);
  useEffect(() => {
    if (
      (taxDetails.hasExemptions && taxDetails.exemptions === undefined) ||
      taxDetails.exemptions.length === 0
    ) {
      addBaseExemption();
    } else if (!taxDetails.exemptions) {
      props.changeFunction('exemptions', undefined, taxIndex);
    }
  }, [taxDetails.hasExemptions]);

  const addBaseExemption = () => {
    let exemptions: Exemption[] = taxDetails.exemptions !== undefined ? [...taxDetails.exemptions] : [];
    const exemption: Exemption = {
      type: undefined,
      savings: undefined,
      vsText: taxDetails.taxDescriptionType?.type,
      isPriorItem: props.isPriorItem,
    };
    exemptions.push(exemption);
    props.changeFunction('exemptions', exemptions, taxIndex);
  };

  const onConfirmCreateOption = () => {
    createOption();
    props.changeFunction('exemptions', newExemption, taxIndex, 'type', newExemptionIndex);
    setShowConfirmCreateOption(false);
  };

  const createOption = async () => {
    await axios
      .post(`/api/property/AddDropdownType`, {
        type: newExemption.label,
        locationTypeId: 1,
        dropdownTypeId: 1,
      })
      .then(getExemptionTypes);
  };

  const onCancelCreateOption = () => {
    props.changeFunction(
      'exemptions',
      { value: undefined, label: undefined },
      taxIndex,
      'type',
      newExemptionIndex
    );
    setShowConfirmCreateOption(false);
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}>
        <Checkbox
          checked={taxDetails.hasExemptions}
          onChange={(e: any) => props.changeFunction('hasExemptions', !taxDetails.hasExemptions, taxIndex)}
          label={'Are there any Exemptions?'}
        />
        {/* <span style={{ marginRight: 16, display: 'inline-block', width: 200 }}>Are there any Exemptions?</span>
        <ToggleCheckBox
          value={taxDetails.hasExemptions}
          onChange={(e: any) => props.changeFunction('hasExemptions', e, taxIndex)}
        /> */}
      </div>
      {taxDetails.hasExemptions ? (
        <div>
          {taxDetails.exemptions.map((ex: Exemption, index: number) => (
            <ExemptionPortion
              index={index}
              exemptionTypes={exemptionTypes}
              addExemption={addExemption}
              exemption={ex}
              taxIndex={taxIndex}
              showDelete={taxDetails.exemptions.length > 1}
              changeFunction={props.changeFunction}
              removeFunction={props.removeFunction}
            />
          ))}
          <div
            style={{
              marginTop: 16,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ActionButton
              icon="PlusIcon"
              backgroundColor={colors.greyOrder}
              styles={{ color: colors.redLight }}
              onClick={() => addBaseExemption()}
            />
            <span style={{ marginLeft: 8, fontWeight: 'bold' }}>Add Exemption</span>
          </div>
        </div>
      ) : null}
      {showConfirmCreateOption && (
        <ConfirmActionModal
          openState={showConfirmCreateOption}
          onClose={onCancelCreateOption}
          header={'Create New Exemption Type'}
          info={`Would you like to add "${newExemption.label}" as a new exemption type?`}
          actionFunction={onConfirmCreateOption}
          buttonText={'Continue'}
        />
      )}
    </React.Fragment>
  );
};

export default Exemptions;
